import { useMutation as t } from "react-query";
import { useEnvironment as n } from "../../../common/hooks/environment/useEnvironment.js";
import { getAdapter as s } from "../../adapter.js";
import { ScopeAdapter as i } from "../../models/scope/scope.adapter.js";
const m = 1;
function d() {
  const {
    backendBaseUrl: e
  } = n();
  return t(
    async (o) => {
      if ((await fetch(`${e}/booking/`, {
        method: "post",
        body: JSON.stringify({
          actions: [m],
          date: o.date,
          time: o.time,
          people: o.people,
          zone: o.zone,
          comments: o.comments,
          contact: {
            external_id: o.customer.externalId,
            marketing_permissions: o.customer.marketingPermissions,
            name: o.customer.name,
            phone: o.customer.phone,
            email: o.customer.email
          },
          scope: s(i).serialize(o.scope)
        })
      })).status !== 200)
        throw new Error("Request failed");
    }
  );
}
export {
  d as useBookingConfirmation
};
//# sourceMappingURL=useBookingConfirmation.js.map
